import { atom, atomFamily } from 'recoil'
import Lib from 'library'
import best50s from './best50'

// 기관목록 가공하기
const setOrgList = async orgCd => {
	// Navigate 로 이동시에만 본 코드가 동작함. Link 이동시엔 최초 1회만 동작.
	// 따라서 초기화는 data/home/index.js 에서 처리함. LBJ
	console.log(" 기관목록 가공하기 시작");
	const data = await Lib.get("api/data/lnkup/instts")
	const newList = []
	data.forEach(item => {
		const indstCd = item.indstCd
		let found = newList.find(item => {
			return item.indstCd === indstCd
		})
		if (!found) {
			found = {
				indstCd: indstCd,
				indstNm: item.indstNm,
				data: [],
				count: 0,
				checkedCount: 0,
				bestCount: 0,
				searchedCount: 0
			}
			newList.push(found)
		}

		const best50 = best50s.some(best => {
			return best.insttCd === item.insttCd
		})

		// const checked = item.insttCd === orgCd
		// index에서 처리하도록 변경
		// FloatLayer.js 에서 group.checkedCount > 0 을 체크하기 때문에 1 이상으로 세팅해야 목록이 보임.

		if (best50) {
			found.bestCount++
		}

		const newItem = {
			...item,
			best50: best50
		}

		found.data.push(newItem)
		found.count++
	})
	console.log(" 기관목록 가공하기 종료");
	return newList
}

// 기관목록
export const orgListState = atomFamily({
	key: "orgListState",
	default: setOrgList,
	/* effects: [({ onSet }) => {
		onSet(newValue => console.log(newValue))
	}] */
})

// best50 레이어
export const showBest50LayerState = atom({
	key: "showBest50LayerState",
	default: false
})

// 검색 레이어
export const showSearchLayerState = atom({
	key: "showSearchLayerState",
	default: false
})